import axiosApiInstance from 'src/api/axiosConfig';

export const fetchCenterData = async (id: number): Promise<any | undefined> => {
    const { data } = await axiosApiInstance.get(`centers/${id}`);

    return data;
};
